import { useSelector } from "react-redux";
import CreateNewForeCasterBase from "./CreateNewForeCasterBase";
import { setDisplayErrorSnackBar, setUserToken } from "../../../../../features/userSlice";
import { useEffect, useState } from "react";
import { forecastersEndPointLogic } from "../../../../../logic/AssetManagement/Forecasters/forecastersEndPointLogic";
import { useDispatch } from "react-redux";
import { useSearchParams, useLocation } from "react-router-dom";
import { setForecastLastTwelveMonthsData, setSelectedTemplateType } from "../../../../../features/forecastersSlice";
import store from "../../../../../store";
import NewForecastForFTD from './NewForecastForFTD';
import NewForecastForGrowth from './NewForecastForGrowth';
import NewForecastForProfit from './NewForecastForProfit';

const CreateNewForeCaste = () => {

  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const selectedSite = searchParams.get("selectedSite") as any;
  const selectedYear = searchParams.get("selectedYear") as any;
  const selectedTemplateType = searchParams.get("predictionFocus") as any;
  const dispatch = useDispatch();  const [open, setOpen] = useState(false);
  const websiteTargetList = useSelector((state: any) => state.forecasters?.websiteTargetList);
  const [loading, setLoading] = useState(true);

  const isTargetFetchable = (targetMonth: string): boolean => {
    if (!targetMonth) return false;
    const [month, year] = targetMonth.split("/").map(Number);
    const quarterStartMonth = Math.floor((month - 1) / 3) * 3 + 1;
    const deadline = new Date(year, quarterStartMonth - 1, 15);
    const today = new Date();
    return today <= deadline;
  };
  const RequiredDataLastMonths = websiteTargetList?.filter((target: any) => {
    const [year, month] = target.month.split("-");
    const formattedMonth = `${parseInt(month)}/${year}`;
    // Check if the target is not fetchable and matches the selected year
    return !isTargetFetchable(formattedMonth) && parseInt(year) === parseInt(selectedYear);
  });
  useEffect(() => {
    if (!selectedTemplateType) {
      setOpen(false);
      setLoading(false);
    } else {
      setLoading(true);
      setOpen(true);
    }
  }, [selectedTemplateType]);

  // if unmounted , reset the value of forecastLastTwelveMonthsData 
  useEffect(() => {
    return () => {
      dispatch(setForecastLastTwelveMonthsData(null));
    };
  }, [dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const predictionFocus = params.get("predictionFocus");

    if (predictionFocus) {
      const focusValue = parseInt(predictionFocus);
      if ([1, 2, 3].includes(focusValue)) {
        dispatch(setSelectedTemplateType(focusValue));
        setOpen(true);
      }
    }
  }, [location.search, dispatch]);

  const QUERY_ID = "5699409840963584";
  useEffect(() => {
    if (selectedSite && selectedYear && selectedTemplateType) {
      setLoading(true);
      const fetchLastTwelveMonthsData = async () => {
        try {
          await Promise.all([
            forecastersEndPointLogic.getForecasterLastTwelveMonthsData(oauthTokenHeader, QUERY_ID, selectedSite, dispatch),
            forecastersEndPointLogic.getAllWebsiteTarget(oauthTokenHeader, selectedSite, dispatch),
          ]);
        } catch (error: any) {
          store.dispatch(setDisplayErrorSnackBar({ message: error.message || "An unknown error occurred", type: "error" })
          );
        } finally {
          setLoading(false);
        }
      }
      fetchLastTwelveMonthsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplateType, selectedSite, oauthTokenHeader, selectedYear]);

  const forecastLastTwelveMonthsData = useSelector((state: any) => {
    const data = state?.forecasters?.forecastLastTwelveMonthsData;
    if (data?.query_output) {
      return {
        ...data,
        query_output: data.query_output.map((item: any) => {
          const transformedItem = { ...item };
          for (const key in transformedItem) {
            if (transformedItem[key] === null) {
              transformedItem[key] = 0;
            }
          }
          return transformedItem;
        }),
      };
    }
    return data;
  });

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const LastYearData = forecastLastTwelveMonthsData?.query_output?.map(
    (row: any) => {
      const [, month] = row?.month.split("-").map(Number);
      const monthName = monthNames[month - 1]; // Get month name for display
      const transformedRow = { ...row, displayMonth: monthName }; // Add displayMonth for UI
      return transformedRow;
    }
  );

  useEffect(() => {
    const initState = { position: 1 };
    window.history.replaceState(initState, "");
    window.history.pushState({ position: 2 }, "");
    const onPopState = (event: PopStateEvent) => {
      if (event.state?.position === 1) {
      }
    };
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [location]);

  const ComponentForForcastCreation:any = {
    1: NewForecastForFTD,
    2: NewForecastForGrowth,
    3: NewForecastForProfit
  };

  const renderComponent  = (type: number) => {
    const Component = ComponentForForcastCreation[type];
    return Component ? <Component LastYearData={LastYearData} RequiredDataLastMonths={RequiredDataLastMonths} loading={loading} setLoading={setLoading} /> : null;
  };

  return (
    <>
      <CreateNewForeCasterBase onViewCreateTable={() => setOpen(true)} loading={loading} />
      {selectedTemplateType && open &&(
        <>
          {renderComponent(selectedTemplateType || "")}
          {/* <CreateNewForeCasterTable
            LastYearData={LastYearData}
            RequiredDataLastMonths={RequiredDataLastMonths}
            loading={loading}
            setLoading={setLoading}
          /> */}
        </>
      )}
    </>
  );
};

export default CreateNewForeCaste;
